// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_navbar__n7ygh {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(34, 34, 34, 0.95);
  padding: 0.75rem 1.5rem;
  color: white;
  border-bottom: none; /* Remove border since bucket navbar will have one */
  position: relative; /* Changed from static to allow z-index */
  width: 100%;
  box-sizing: border-box;
  height: 70px;
  z-index: 100; /* Ensure navbar stays above brightness overlay (higher than BucketNavbar) */
  transition: background-color 0.5s ease;
}

.Navbar_timerActive__Lxxex {
  background-color: #004d00; /* Dark green */
}

.Navbar_navbarBrand__MrF9L {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.Navbar_logo__jA5Pb {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.Navbar_brandText__ALFwV {
  font-size: 1.5rem;
  font-weight: bold;
  color: #4a9eff;
}

.Navbar_navbarActions__K3iTT {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.Navbar_actionButton__SV7\\+s {
  background-color: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
  letter-spacing: 0.02em;
}

.Navbar_actionButton__SV7\\+s:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.25);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.Navbar_actionButton__SV7\\+s:active {
  transform: translateY(0);
  background-color: rgba(255, 255, 255, 0.1);
}


.Navbar_navbarUser__x6CIJ {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.Navbar_username__AdlFR {
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.Navbar_adminBadge__HAYoR {
  background-color: #4a9eff;
  color: white;
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-weight: bold;
  text-transform: uppercase;
}

.Navbar_logoutButton__lKhAe {
  background-color: transparent;
  border: 1px solid #666;
  color: white;
  padding: 0.4rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.Navbar_logoutButton__lKhAe:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: #999;
}

.Navbar_switchContainer__7YJ67 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.Navbar_switchLabel__U-Fkj {
  font-size: 0.9rem;
  color: #ccc;
  font-weight: 500;
}

.Navbar_switch__Wdj8b {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: #666;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.Navbar_switchOn__zxxKo {
  background-color: #4a9eff;
}

.Navbar_switchOff__ST\\+O9 {
  background-color: #666;
}

.Navbar_switchHandle__WbMDJ {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.Navbar_switchOn__zxxKo .Navbar_switchHandle__WbMDJ {
  transform: translateX(20px);
}

.Navbar_switch__Wdj8b:hover {
  box-shadow: 0 0 8px rgba(74, 158, 255, 0.3);
}

/* Mobile styles */
@media (max-width: 768px) {
  .Navbar_navbar__n7ygh {
    padding: 0.5rem 1rem !important;
    height: 60px !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 100 !important;
  }

  /* Hide brand text on mobile */
  .Navbar_brandText__ALFwV {
    display: none !important;
  }

  /* Hide actions on mobile - they'll be in a dropdown */
  .Navbar_navbarActions__K3iTT {
    display: none !important;
  }

  /* Compact user section */
  .Navbar_navbarUser__x6CIJ {
    gap: 0.5rem !important;
  }

  .Navbar_username__AdlFR {
    font-size: 0.9rem !important;
  }

  .Navbar_logoutButton__lKhAe {
    padding: 0.3rem 0.6rem !important;
    font-size: 0.8rem !important;
  }

  /* Logo adjustments */
  .Navbar_logo__jA5Pb {
    height: 35px !important;
  }

  /* Ensure no overflow */
  .Navbar_navbar__n7ygh {
    overflow-x: hidden !important;
    width: 100vw !important;
    max-width: 100vw !important;
    box-sizing: border-box !important;
  }

  /* Mobile dropdown styles */
  .Navbar_mobileDropdown__OonMN {
    position: relative;
    display: block !important;
  }

  .Navbar_dropdownButton__9yJC9 {
    background: none !important;
    border: none !important;
    color: white !important;
    font-size: 1.5rem !important;
    padding: 0.5rem !important;
    cursor: pointer !important;
    border-radius: 4px !important;
    transition: all 0.2s !important;
  }

  .Navbar_dropdownButton__9yJC9:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  .Navbar_dropdownMenu__xlZS9 {
    position: absolute !important;
    top: 100% !important;
    right: 0 !important;
    background-color: rgba(34, 34, 34, 0.98) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 6px !important;
    min-width: 150px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5) !important;
    z-index: 9999 !important;
    padding: 0.5rem 0 !important;
    backdrop-filter: blur(10px) !important;
    margin-top: 5px !important;
  }

  .Navbar_dropdownItem__POg6i {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    padding: 0.75rem 1rem !important;
    background: none !important;
    border: none !important;
    color: white !important;
    font-size: 0.9rem !important;
    cursor: pointer !important;
    transition: all 0.2s !important;
    width: 100% !important;
    text-align: left !important;
  }

  .Navbar_dropdownItem__POg6i:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  .Navbar_dropdownItem__POg6i .Navbar_switch__Wdj8b {
    margin-left: 0.5rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,uBAAuB;EACvB,YAAY;EACZ,mBAAmB,EAAE,oDAAoD;EACzE,kBAAkB,EAAE,yCAAyC;EAC7D,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,YAAY,EAAE,4EAA4E;EAC1F,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC;EAChC,2CAA2C;EAC3C,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,kBAAkB;AAClB;EACE;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,8BAA8B;EAC9B;IACE,wBAAwB;EAC1B;;EAEA,sDAAsD;EACtD;IACE,wBAAwB;EAC1B;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA,qBAAqB;EACrB;IACE,uBAAuB;EACzB;;EAEA,uBAAuB;EACvB;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA,2BAA2B;EAC3B;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,6BAA6B;IAC7B,+BAA+B;EACjC;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,mDAAmD;IACnD,qDAAqD;IACrD,6BAA6B;IAC7B,2BAA2B;IAC3B,oDAAoD;IACpD,wBAAwB;IACxB,4BAA4B;IAC5B,sCAAsC;IACtC,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,gCAAgC;IAChC,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,+BAA+B;IAC/B,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: rgba(34, 34, 34, 0.95);\n  padding: 0.75rem 1.5rem;\n  color: white;\n  border-bottom: none; /* Remove border since bucket navbar will have one */\n  position: relative; /* Changed from static to allow z-index */\n  width: 100%;\n  box-sizing: border-box;\n  height: 70px;\n  z-index: 100; /* Ensure navbar stays above brightness overlay (higher than BucketNavbar) */\n  transition: background-color 0.5s ease;\n}\n\n.timerActive {\n  background-color: #004d00; /* Dark green */\n}\n\n.navbarBrand {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.logo {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n}\n\n.brandText {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #4a9eff;\n}\n\n.navbarActions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.actionButton {\n  background-color: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.85);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(10px);\n  letter-spacing: 0.02em;\n}\n\n.actionButton:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.25);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.actionButton:active {\n  transform: translateY(0);\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n\n.navbarUser {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.username {\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.adminBadge {\n  background-color: #4a9eff;\n  color: white;\n  font-size: 0.7rem;\n  padding: 0.2rem 0.4rem;\n  border-radius: 4px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.logoutButton {\n  background-color: transparent;\n  border: 1px solid #666;\n  color: white;\n  padding: 0.4rem 0.75rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.logoutButton:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: #999;\n}\n\n.switchContainer {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.switchLabel {\n  font-size: 0.9rem;\n  color: #ccc;\n  font-weight: 500;\n}\n\n.switch {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  background-color: #666;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.switchOn {\n  background-color: #4a9eff;\n}\n\n.switchOff {\n  background-color: #666;\n}\n\n.switchHandle {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.switchOn .switchHandle {\n  transform: translateX(20px);\n}\n\n.switch:hover {\n  box-shadow: 0 0 8px rgba(74, 158, 255, 0.3);\n}\n\n/* Mobile styles */\n@media (max-width: 768px) {\n  .navbar {\n    padding: 0.5rem 1rem !important;\n    height: 60px !important;\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    z-index: 100 !important;\n  }\n\n  /* Hide brand text on mobile */\n  .brandText {\n    display: none !important;\n  }\n\n  /* Hide actions on mobile - they'll be in a dropdown */\n  .navbarActions {\n    display: none !important;\n  }\n\n  /* Compact user section */\n  .navbarUser {\n    gap: 0.5rem !important;\n  }\n\n  .username {\n    font-size: 0.9rem !important;\n  }\n\n  .logoutButton {\n    padding: 0.3rem 0.6rem !important;\n    font-size: 0.8rem !important;\n  }\n\n  /* Logo adjustments */\n  .logo {\n    height: 35px !important;\n  }\n\n  /* Ensure no overflow */\n  .navbar {\n    overflow-x: hidden !important;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Mobile dropdown styles */\n  .mobileDropdown {\n    position: relative;\n    display: block !important;\n  }\n\n  .dropdownButton {\n    background: none !important;\n    border: none !important;\n    color: white !important;\n    font-size: 1.5rem !important;\n    padding: 0.5rem !important;\n    cursor: pointer !important;\n    border-radius: 4px !important;\n    transition: all 0.2s !important;\n  }\n\n  .dropdownButton:hover {\n    background-color: rgba(255, 255, 255, 0.1) !important;\n  }\n\n  .dropdownMenu {\n    position: absolute !important;\n    top: 100% !important;\n    right: 0 !important;\n    background-color: rgba(34, 34, 34, 0.98) !important;\n    border: 1px solid rgba(255, 255, 255, 0.2) !important;\n    border-radius: 6px !important;\n    min-width: 150px !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5) !important;\n    z-index: 9999 !important;\n    padding: 0.5rem 0 !important;\n    backdrop-filter: blur(10px) !important;\n    margin-top: 5px !important;\n  }\n\n  .dropdownItem {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    padding: 0.75rem 1rem !important;\n    background: none !important;\n    border: none !important;\n    color: white !important;\n    font-size: 0.9rem !important;\n    cursor: pointer !important;\n    transition: all 0.2s !important;\n    width: 100% !important;\n    text-align: left !important;\n  }\n\n  .dropdownItem:hover {\n    background-color: rgba(255, 255, 255, 0.1) !important;\n  }\n\n  .dropdownItem .switch {\n    margin-left: 0.5rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `Navbar_navbar__n7ygh`,
	"timerActive": `Navbar_timerActive__Lxxex`,
	"navbarBrand": `Navbar_navbarBrand__MrF9L`,
	"logo": `Navbar_logo__jA5Pb`,
	"brandText": `Navbar_brandText__ALFwV`,
	"navbarActions": `Navbar_navbarActions__K3iTT`,
	"actionButton": `Navbar_actionButton__SV7+s`,
	"navbarUser": `Navbar_navbarUser__x6CIJ`,
	"username": `Navbar_username__AdlFR`,
	"adminBadge": `Navbar_adminBadge__HAYoR`,
	"logoutButton": `Navbar_logoutButton__lKhAe`,
	"switchContainer": `Navbar_switchContainer__7YJ67`,
	"switchLabel": `Navbar_switchLabel__U-Fkj`,
	"switch": `Navbar_switch__Wdj8b`,
	"switchOn": `Navbar_switchOn__zxxKo`,
	"switchOff": `Navbar_switchOff__ST+O9`,
	"switchHandle": `Navbar_switchHandle__WbMDJ`,
	"mobileDropdown": `Navbar_mobileDropdown__OonMN`,
	"dropdownButton": `Navbar_dropdownButton__9yJC9`,
	"dropdownMenu": `Navbar_dropdownMenu__xlZS9`,
	"dropdownItem": `Navbar_dropdownItem__POg6i`
};
export default ___CSS_LOADER_EXPORT___;
